import React, { useState } from "react";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import Moment from 'react-moment';

import servicioDescargaArchivos from '../servicios/ServicioDescargaArchivos';
import { esObjetoVacio } from '../servicios/ServicioObjetos';
export const TablaConsultas = (props) => {
    const { paginacion, funcionPaginacion } = props;

    const [first, setFirst] = useState(0);


    const formatofechaCreacion = (rowData, column) => {
        return <Moment format="YYYY-MM-DD HH:mm:ss">
            {rowData.twCfdi.fechaCreacion}
        </Moment>;
    }

    const formatofechaCertificacion = (rowData, column) => {
        if (!rowData.twCfdi.fechaCertificacion) {
            return "";
        } else {
            return <Moment format="YYYY-MM-DD HH:mm:ss">
                {rowData.twCfdi.fechaCertificacion}
            </Moment>;
        }
    }
    const formatofechaCancelacion = (rowData, column) => {
        if (!rowData.twCfdi.fechaCancelacion) {
            return "";
        } else {
            return <Moment format="YYYY-MM-DD HH:mm:ss">
                {rowData.twCfdi.fechaCancelacion}
            </Moment>;
        }
    }

    const formatoEstatus = (rowData, column) => {
        if (rowData.twCfdi.estado === 6)
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Cancelado</p>;
        else
            return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>
    }

    const templateDescargaArchivos = (rowData, column) => {
        return <div>
            <Button type="button" icon="pi pi-download" className="p-button-success" onClick={(e) => descargaArchivos(rowData)}></Button>
        </div>;
    }

    const descargaArchivos = (rowData) => {
        servicioDescargaArchivos.descargaArchivo('documentos/cfdi/descargazip.json', { id: rowData.twCfdi.id });
    }
    const onPage = (event) => {
        setFirst(event.first);
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        funcionPaginacion();
    }

    return (<div>{
        esObjetoVacio(paginacion.datos) ? null : <div className="card card-w-title">
            <DataTable value={paginacion.datos} editable={true} scrollable={true} scrollHeight="280px" autoLayout={true} >
                <Column field="twCfdi.uuid" header="Folio fiscal" style={{ width: '200px' }} />
                <Column field="twCfdi.total" header="Importe total" style={{ width: '200px' }} />
                <Column body={formatofechaCreacion} header="Fecha creación" style={{ width: '200px' }} />
                <Column body={formatofechaCertificacion} header="Fecha certificación" style={{ width: '200px' }} />
                <Column body={formatofechaCancelacion} header="Fecha cancelación" style={{ width: '200px' }} />
                <Column field="twCfdi.formaPago" header="Forma Pago" style={{ width: '200px' }} />
                <Column field="twCfdi.metodoPago" header="Método Pago" style={{ width: '200px' }} />
                <Column field="twCfdi.totalImpuestosTrasladados" header="Metodo Pago" style={{ display: 'none' }} />
                <Column field="twCfdi.totalImpuestosRetenidos" header="Metodo Pago" style={{ display: 'none' }} />
                <Column body={formatoEstatus} header="Estado factura" style={{ width: '200px' }} />
                <Column field="twCfdi.llaveCfdi" header="Metodo Pago" style={{ display: 'none' }} />
                <Column field="twCfdi.direccionCfdiSinFirma" header="Metodo Pago" style={{ display: 'none' }} />
                <Column field="twCfdi.direccionCfdiFirmado" header="Metodo Pago" style={{ display: 'none' }} />
                <Column field="twCfdi.direccionCfdiAcuseCancelacion" header="Metodo Pago" style={{ display: 'none' }} />
                <Column field="twCfdi.direccionAcuseRecibo" header="Metodo Pago" style={{ display: 'none' }} />
                <Column field="twCfdi.folio" header="Folio" style={{ width: '200px' }} />
                <Column field="twCfdi.serie" header="Serie" style={{ width: '200px' }} />
                <Column header="Descargar archivos" body={templateDescargaArchivos} style={{ textAlign: 'center', width: '12em' }} />
            </DataTable>
            
           <Paginator totalRecords={paginacion.registrosTotales} rows={paginacion.registrosPorPagina}  
            first={first} onPageChange={onPage} rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} 
            template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" 
            currentPageReportTemplate={"Total: "+paginacion.registrosTotales+", Página ({currentPage} de {totalPages})"} />
        </div>}

    </div>);
}